<template>
  <div>

    <fieldset>

      <h2>
        Foto’s toevoegen
      </h2>
      <p>Volg de volgende stappen zodat je de beste foto’s bij je meting toevoegt.</p>

      <ol>
        <li>Open de camera app op je telefoon</li>
        <li>Maak een foto <strong>recht vooruit</strong> over het water</li>
        <li>Maak een foto <strong>schuin langs</strong> de oever</li>
        <li>Maak een foto <strong>van boven</strong> op het water</li>
        <li>Keer terug naar dit formulier</li>
        <li>Ga naar de volgende pagina en upload je foto’s </li>
      </ol>

    </fieldset>
    <nav>
      <button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
      <button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">Volgende</button>
    </nav>
  </div>
</template>

<script>
import FormStep from "./FormStep.vue";

export default {
  name: "FormStep4",
  mixins: [FormStep],
  data(){
    return {
      fieldRequirements: {
      }
    }
  },
}
</script>

<style scoped>
  ol {
		padding: 0;
    margin: 0 0 82px;
		counter-reset: item;
  }

  li {
    color: #374151;
    display: block;
    background-image: none;
    padding-left: 41px;
    counter-increment: item;
    position: relative;
    font-weight: 300;
    font-size: 1.6rem;
  }
  li strong {
    font-weight: bold;
  }
  li:before {
    content: counter(item);
    border: solid 1px rgba(55,65,81, 0.5);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 29px;
    height: 29px;
    position: absolute;
    left: 0;
    top: -6px;
    font-size: 1.4rem;
  }

  li + li {
    margin-top: 33px;
  }
</style>
